import { render, staticRenderFns } from "./configTable.vue?vue&type=template&id=4a3a5051&scoped=true"
import script from "./configTable.vue?vue&type=script&lang=js"
export * from "./configTable.vue?vue&type=script&lang=js"
import style0 from "./configTable.vue?vue&type=style&index=0&id=4a3a5051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a5051",
  null
  
)

export default component.exports